

// Menu drawer code to change tab
$(document).on("click",".tabs .tablinksone",function() {
  $(".tablinkstwo").removeClass("active")
     $(this).addClass("active");
     $(".drawer__content .tabcontent").removeClass("active");
       $(".drawer__content #tab1").addClass("active");
    
});

$(document).on("click",".tabs .tablinkstwo",function() {
  $(".tablinksone").removeClass("active")
     $(this).addClass("active");
     $(".drawer__content .tabcontent").removeClass("active");
       $(".drawer__content #tab2").addClass("active");
    
});

// $(document).on("click",".customstickyselect",function() {
//   var data = $(this).attr("data-qty");   
//   $(".qty-discount-input").attr("value",data);
// });

$(document).ready(function(){
  $(".category_list .category_arrow").click(function(){
    var $categoryList = $(this).closest(".category_list");
    $categoryList.find(".category_icons").slideToggle("slow");
    $categoryList.find(".category_arrow").toggleClass("open_category");
  });
});


document.addEventListener('cart:updated', function(event) {
   setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});

document.addEventListener('variant:added', function(event) {
   setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});

$(document).on("click",".custom_recoment_cart",function() {
   setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});

$(document).on("click",".add-to-carts",function() {
     setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});


$(document).ready(function(){
   setTimeout(function () {
ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
   }, 2500);
  });

document.addEventListener('cart:updated', function(event) {
   setTimeout(function () {
ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
   }, 2500);
  
 });


  document.addEventListener('variant:added', function(event) {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
// console.log("Fffffff")
    
  });

$(document).on("click",".add-to-carts",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 2500);
console.log("Fffffff")
    
  });

$(document).on("click",".custom_recoment_cart",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 2500);
console.log("Fffffff")
    
  });

$(document).on("click",".pagination__nav-item",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 1000);
console.log("Fffffff")
    
  });


$(document).on("click",".popover__choice-item",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 1000);
console.log("Fffffff")
    
  });

$(document).on("click",".checkbox-container",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 1000);
console.log("Fffffff")
    
  });

$("#reviews_container").on('click', function(){ 
     $('html').addClass('lock-all');
      $("#mini-cart").attr('open','open');
})
$(document).on("click","body #reviews_fade, body #reviews_widget, body #reviews_container",function() {

  $('html').addClass('lock-all');
  //document.getElementsByClassName('mini_cart_drawer')[0].setAttribute("open", "open");
  $("#mini-cart").attr('open','open');
});